import axios from "axios";

class DealsService {

    constructor() {
        this.apiBaseUrl = process.env.REACT_APP_DEALS_URL;
        this.restClient = axios.create({
            baseURL: this.apiBaseUrl
        });
    }

    getDealsForDevice(deviceId) {
        return this.restClient.get(`/EBU/devices/${deviceId}/deals`)
    }
}

export default new DealsService();
